import React, { useContext, useEffect } from "react";
import LoginFooter from '../../components/Footers/LoginFooter';
import AdminHeader from '../../components/Headers/AdminHeader';
import ScheduleEmails from "../../components/ScheduleEmails";
import { UserContext } from '../../context/User';
import { useHistory } from 'react-router-dom';

const ScheduleEmailsPage = () => {
  const { user } = useContext(UserContext);
  const role = user && user.roles && user.roles[0].role_description;
  const history = useHistory();

  useEffect(() => {
   if (role !== "admin") {
      history.push("/dashboard");
    }
  }, []);

  return (
    <>  
      <AdminHeader />
      <main>
        {role === "admin" && <ScheduleEmails />}
      </main>
      <LoginFooter />
    </>
  );
}

export default ScheduleEmailsPage;